import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { HELP_CENTER_CHAT_MESSENGER_WINDOW_TITLE_230413 } from "@faire/web-api/indigofair/settings/HELP_CENTER_CHAT_MESSENGER_WINDOW_TITLE_230413";
export function getSettingChatMessengerWindowTitle() {
  return getSettingValueWithoutAssignment(HELP_CENTER_CHAT_MESSENGER_WINDOW_TITLE_230413, "Faire Support");
}